import Vuex from "vuex";
import Vue from "vue";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        leaderboardData: {
            linked: {
                999: null,
                7: null,
                30: null
            },
            all: {
                999: null,
                7: null,
                30: null
            }
        },
        numDays: 7,
        type: "linked",
        loading: false
    },
    getters: {
        leaderboardData: (state) => {
            return state.leaderboardData[state.type][state.numDays] || null;
        },
        numDays: (state) => {
            return state.numDays;
        },
        type: (state) => {
            return state.type;
        }
    },
    mutations: {
        setLeaderboardData(state, { leaderboardData, numDays, type }) {
            Vue.set(state.leaderboardData[type], numDays, leaderboardData);
        },
        setLoading(state, val) {
            state.loading = val;
        },
        setType(state, val) {
            state.type = val;
        },
        setNumDays(state, val) {
            state.numDays = val;
        }
    },
    actions: {
        setType({ dispatch, commit, state }, type) {
            commit("setType", type);
            if (!state.leaderboardData[state.type][state.numDays]) {
                dispatch("updateLeaderboard");
            }
        },
        setNumDays({ dispatch, commit, state }, numDays) {
            commit("setNumDays", numDays);
            if (!state.leaderboardData[state.type][state.numDays]) {
                dispatch("updateLeaderboard");
            }
        },
        async updateLeaderboard({ commit, state }) {
            commit("setLoading", true);
            axios
                .get(
                    `https://i0tr7oa202.execute-api.us-east-1.amazonaws.com/dev/getleaderboard?days=${state.numDays}&linkedOnly=${state.type ===
                        "linked"}`
                )
                .then((response) => {
                    commit("setLeaderboardData", { numDays: state.numDays, type: state.type, leaderboardData: response.data.leaderboard });
                    commit("setLoading", false);
                });
        }
    }
});
